import store from "../../Redux/store";
import { setStationData, countStationData } from "./StationData.reducer";

export function saveListStationData(records) {
  store.dispatch(setStationData(records));
}

export function saveCountStationData(count) {
  store.dispatch(countStationData(count));
}